/**
* Declerations
*/

// mixins
import {mapMixins} from '@/mixins/mapMixins';
import {ordermixins} from '@/mixins/ordermixins'

//Helper
import Helper from '@/helpers/helper'

export const deliverylistmixins = {
    mixins : [mapMixins, ordermixins],
    props : {
        ordergroup : {
            type   : Array,
            default: () => []
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Check if group has accpeted order
         * @param group 
         */
        checkhasaccepted(group) {
            const accepted = group.orders.filter(o => o.order.status == 'accepted' || o.order.status == 'amend')

            return accepted.length > 0 ? true : false
        },
         /**
         * View order details
         * @param id assigned record id
         */
        viewOrder(order){
            this.$router.push({
                name : 'order',
                params : {id : order.id}
            })
        },
        /**
         * Check if order status is accepted
         * @param order
         * @param status
         */
        checkstatus(order, status) {
            if(status == 'accepted') {
                return order.order.status == 'accepted' || order.order.status == 'amend' ? true : false
            } else {
                return order.order.status == status ? true : false
            }
        },
    }
}